import { render, staticRenderFns } from "./CommitteeProfile.vue?vue&type=template&id=17c9beee&scoped=true"
import script from "./CommitteeProfile.vue?vue&type=script&lang=js"
export * from "./CommitteeProfile.vue?vue&type=script&lang=js"
import style0 from "./CommitteeProfile.vue?vue&type=style&index=0&id=17c9beee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17c9beee",
  null
  
)

export default component.exports